// extracted by mini-css-extract-plugin
export default {"AppMenuList":"Navigation_AppMenuList__Iu0SI","AppMenuList__right":"Navigation_AppMenuList__right__oKEAr","AppMenuList--vertical":"Navigation_AppMenuList--vertical__r6r88"};